import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../../components/forms/ConfirmForm";
import {cancelRunService} from "../../../actions/InfrastructureApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";


class RunServiceFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.runServiceNow({serviceId: this.props.serviceId})
      .then((response) => {
        if (response.data.runServiceNow.errors.length <= 0) {
          this.props.cancelRunService();
        } else {
          let errors = createValidationErrors(response.data.runServiceNow.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRunService();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to run this service now? It is possible that it will cause more than one instance to run if already running. Please note that the service must be started."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const START_SERVICE = gql`
  mutation runServiceNow($data: InfrastructureStartServiceInput!) {
    runServiceNow(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(START_SERVICE, {
    props: ({ mutate }) => ({
      runServiceNow: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRunService})(withQuery(RunServiceFormContainer));